
    import '/opt/buildhome/repo/components/conversations/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["conversations-demo-basic","conversations-demo-with-menu","conversations-demo-menu-trigger","conversations-demo-controlled-mode","conversations-demo-group","conversations-demo-group-sort","conversations-demo-infinite-load"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/conversations/index.zh-CN.md?type=demo')
};